import React from 'react';
import { StatusBadge } from '../../common';

/**
 * Session suitability rows — card list (mobile-friendly, no table scroll).
 */
export default function ClubAnalysisSessionSummaryList({
  summaries = [],
  selectedSessionId,
  onSelectSession,
}) {
  if (!summaries.length) {
    return null;
  }

  return (
    <div className="space-y-2">
      {summaries.map((s) => {
        const isSelected = selectedSessionId === s.sessionId;
        return (
          <button
            key={s.sessionId}
            type="button"
            onClick={() => onSelectSession(isSelected ? 'all' : s.sessionId)}
            className={`w-full rounded-lg border p-3 text-left transition-colors touch-manipulation ${
              isSelected
                ? 'border-primary/40 bg-primary/10'
                : 'border-border-medium bg-surface-subtle hover:bg-surface-elevated'
            }`}
          >
            <div className="flex items-start justify-between gap-2">
              <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-semibold text-text-primary">{s.sessionName}</p>
                <p className="mt-1 text-xs text-text-secondary">
                  {s.gamesPlayed} games · {s.winRate}% win rate ·{' '}
                  {s.totalEloChange > 0 ? '+' : ''}
                  {s.totalEloChange} ELO
                </p>
              </div>
              <StatusBadge variant={s.variant} size="small" className="shrink-0">
                {s.suitability}
              </StatusBadge>
            </div>
            {isSelected ? (
              <p className="mt-2 text-xs font-medium text-primary">Filtering game history by this session</p>
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
